export enum CreativeItemType {
  Image = 'image',
  Video = 'video',
  Carousel = 'carousel',
  DynamicImage = 'dynamic_image',
  DynamicVideo = 'dynamic_video',
  Unknown = 'unknown',
}

export enum CreativeAssetType {
  Image = 'image',
  Video = 'video',
}

export interface CreativeAsset {
  id: string;
  type: CreativeAssetType;
  url: string | null;
  previewImageUrl: string;
}

export interface CreativeItem {
  creativeId: string;
  creativeName: string;
  adId: string;
  adName: string;
  accountId: string;
  sourceName: string;
  type: CreativeItemType;
  thumbnailUrl: string;
  videoPreviewUrl: string;
  assets: CreativeAsset[];
}
